<template>
  <footer>
    <section data-nosnippet>
      <b-container fluid class="kub-footer" :class="{'fixed-bottom': lg}">
        <b-row v-if="lg" class="kub-max-width-footer pt-5">
          <b-col cols="12" md="">
            <div class="text-uppercase mb-2 kub-footer-area-title">{{footer.information.title}}</div>
            <ul class="kub-footer-list">
              <li class="mb-1">
                <a target="_blank" rel="noopener noreferrer" :href="footer.information.links.blog.src" class="text-decoration-none kub-footer-link">{{footer.information.links.blog.name}}</a>
              </li>
              <li class="mb-1" v-for="item in footer.information.modal" :key="item.id">
                <span v-b-modal="item.modal">{{item.name}}</span>
                <b-modal :id="item.modal" centered scrollable :title="item.header" title-tag="h2">
                  <component :is="item.comp"></component>
                  <template #modal-footer="{ ok }">
                    <b-button class="kub-btn" size="sm" @click="ok()">
                      <span class="pl-2 pr-2">OK</span>
                    </b-button>
                  </template>
                </b-modal>
              </li>
            </ul>
          </b-col>
          <b-col cols="12" md="">
            <div class="text-uppercase mb-2 kub-footer-area-title">{{footer.legal.title}}</div>
            <ul class="kub-footer-list">
              <li class="mb-1" v-for="item in footer.legal.modal" :key="item.id">
                <span v-b-modal="item.modal">{{item.name}}</span>
                <b-modal :id="item.modal" centered scrollable size="xl" :title="item.header" title-tag="h2">
                  <component :is="item.comp"></component>
                  <template #modal-footer="{ ok }">
                    <b-button class="kub-btn" size="sm" @click="ok()">
                      <span class="pl-2 pr-2">OK</span>
                    </b-button>
                  </template>
                </b-modal>
              </li>
            </ul>
          </b-col>
          <b-col cols="12" md="">
            <div class="text-uppercase mb-2 kub-footer-area-title">{{footer.contact.title}}</div>
            <b-row style="margin-bottom:1rem;">
              <b-col cols="auto">
                <b-icon icon="house-door-fill" class="mr-2" font-scale="1" style="color:#ccc;"></b-icon>
              </b-col>
              <b-col class="p-0">
                <ul style="color:#ccc;">
                  <li>{{contact.company.content}}</li>
                  <li>{{contact.street.content}} {{contact.number.content}}</li>
                  <li>{{contact.zip.content}} {{contact.city.content}}</li>
                </ul>
              </b-col>
              <div class="w-100"></div>
              <b-col cols="auto">
                <b-icon icon="telephone-fill" class="mr-2" font-scale="1" style="color:#ccc;"></b-icon>
              </b-col>
              <b-col class="p-0" style="color:#ccc;">
                <a class="kub-footer-link" :href="'tel:' + contact.phoneTo.content">{{ contact.phone.content }}</a>
              </b-col>
              <div class="w-100" style="margin-bottom:1rem;"></div>
              <b-col cols="auto">
                <b-icon icon="envelope-fill" class="mr-2" font-scale="1" style="color:#ccc;"></b-icon>
              </b-col>
              <b-col class="p-0" style="color:#ccc;">
                <a class="kub-footer-link" :href="'mailto:' + contact.mail.content">{{ contact.mail.content }}</a>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="auto">
            <div class="text-uppercase mb-2 kub-footer-area-title">{{footer.paymentMethods.title}}</div>
            <b-row>
              <b-col>
                <ul class="kub-footer-list-inline">
                  <li class="mr-2">
                    <div class="kub-footer-payment-box">
                      <img :src="payment.methods.paypal.img.src" :alt="payment.methods.paypal.img.alt">
                    </div>
                  </li>
                  <li>
                    <div class="kub-footer-payment-box">
                      <img id="kub-footer-icon-bill" :src="payment.methods.bill.img.src" :alt="payment.methods.bill.img.alt">
                    </div>
                  </li>
                </ul>
              </b-col>
            </b-row>
            <div class="text-uppercase my-2 kub-footer-area-title">{{footer.socialmedia.title}}</div>
            <b-row>
              <b-col>
                <ul class="kub-footer-list-inline">
                  <li class="mr-2">
                    <a target="_blank" rel="noopener noreferrer" :href="footer.socialmedia.platform.facebook.href">
                      <img :src="footer.socialmedia.platform.facebook.img.src" :alt="footer.socialmedia.platform.facebook.img.alt" style="width:40px;">
                    </a>
                  </li>
                  <li class="mr-2">
                    <a target="_blank" rel="noopener noreferrer" :href="footer.socialmedia.platform.youtube.href">
                      <img :src="footer.socialmedia.platform.youtube.img.src" :alt="footer.socialmedia.platform.youtube.img.alt" style="width:40px;">
                    </a>
                  </li>
                  <li class="">
                    <a target="_blank" rel="noopener noreferrer" :href="footer.socialmedia.platform.pinterest.href">
                      <img :src="footer.socialmedia.platform.pinterest.img.src" :alt="footer.socialmedia.platform.pinterest.img.alt" style="width:40px;">
                    </a>
                  </li>
                </ul>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-else class="pt-3">
          <b-col>
            <b-card no-body class="kub-footer-card-style">
              <b-card-header role="tab" class="p-0" style="border:none;">
                <b-button class="text-decoration-none d-flex kub-footer-btn-mobile" href="#" v-b-toggle="footer.information.toggle" squared block variant="link">
                  <div class="text-uppercase my-1 kub-footer-area-title">{{footer.information.title}}</div>
                  <b-icon icon="plus" scale="1.5" class="when-closed align-self-center ml-auto"></b-icon>
                  <b-icon icon="dash" scale="1.5" class="when-opened align-self-center ml-auto"></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse :id="footer.information.toggle" accordion="kub-footer-accordion" role="tabpanel">
                  <b-card-body class="pt-1 pb-0">
                    <b-card-text>
                      <b-container fluid class="pl-2">
                        <b-row>
                          <ul class="kub-footer-list">
                            <li class="mb-2">
                              <a target="_blank" rel="noopener noreferrer" :href="footer.information.links.blog.src" class="text-decoration-none kub-footer-link">{{footer.information.links.blog.name}}</a>
                            </li>
                            <li class="mb-2" v-for="item in footer.information.modal" :key="item.id">
                              <span v-b-modal="item.modal">{{item.name}}</span>
                              <b-modal :id="item.modal" centered scrollable :title="item.header" title-tag="h2">
                                <component :is="item.comp"></component>
                                <template #modal-footer="{ ok }">
                                  <b-button class="kub-btn" size="sm" @click="ok()">
                                    <span class="pl-2 pr-2">OK</span>
                                  </b-button>
                                </template>
                              </b-modal>
                            </li>
                          </ul>
                        </b-row>
                      </b-container>
                    </b-card-text>
                  </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
          <div class="w-100"></div>
          <b-col>
            <b-card no-body class="kub-footer-card-style">
              <b-card-header role="tab" class="p-0" style="border:none;">
                <b-button class="text-decoration-none d-flex kub-footer-btn-mobile" href="#" v-b-toggle="footer.legal.toggle" squared block variant="link">
                  <div class="text-uppercase my-1 kub-footer-area-title">{{footer.legal.title}}</div>
                  <b-icon icon="plus" scale="1.5" class="when-closed align-self-center ml-auto"></b-icon>
                  <b-icon icon="dash" scale="1.5" class="when-opened align-self-center ml-auto"></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse :id="footer.legal.toggle" accordion="kub-footer-accordion" role="tabpanel">
                  <b-card-body class="pt-1 pb-0">
                    <b-card-text>
                      <b-container fluid class="pl-2">
                        <b-row>
                          <ul class="kub-footer-list">
                            <li class="mb-2" v-for="item in footer.legal.modal" :key="item.id">
                              <span v-b-modal="item.modal">{{item.name}}</span>
                              <b-modal :id="item.modal" centered scrollable size="xl" :title="item.header" title-tag="h2">
                                <component :is="item.comp"></component>
                                <template #modal-footer="{ ok }">
                                  <b-button class="kub-btn" size="sm" @click="ok()">
                                    <span class="pl-2 pr-2">OK</span>
                                  </b-button>
                                </template>
                              </b-modal>
                            </li>
                          </ul>
                        </b-row>
                      </b-container>
                    </b-card-text>
                  </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
          <div class="w-100"></div>
          <b-col>
            <b-card no-body class="kub-footer-card-style">
              <b-card-header role="tab" class="p-0" style="border:none;">
                <b-button class="text-decoration-none d-flex kub-footer-btn-mobile" href="#" v-b-toggle="footer.contact.toggle" squared block variant="link">
                  <div class="text-uppercase my-1 kub-footer-area-title">{{footer.contact.title}}</div>
                  <b-icon icon="plus" scale="1.5" class="when-closed align-self-center ml-auto"></b-icon>
                  <b-icon icon="dash" scale="1.5" class="when-opened align-self-center ml-auto"></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse :id="footer.contact.toggle" accordion="kub-footer-accordion" role="tabpanel">
                  <b-card-body class="pt-1 pb-0">
                    <b-card-text>
                      <b-row style="margin-bottom:1rem;">
                        <b-col cols="auto">
                          <b-icon icon="house-door-fill" class="mr-2" font-scale="1" style="color:#ccc;"></b-icon>
                        </b-col>
                        <b-col class="p-0">
                          <ul style="color:#ccc;">
                            <li>{{contact.company.content}}</li>
                            <li>{{contact.street.content}} {{contact.number.content}}</li>
                            <li>{{contact.zip.content}} {{contact.city.content}}</li>
                          </ul>
                        </b-col>
                        <div class="w-100"></div>
                        <b-col cols="auto">
                          <b-icon icon="telephone-fill" class="mr-2" font-scale="1" style="color:#ccc;"></b-icon>
                        </b-col>
                        <b-col class="p-0" style="color:#ccc;">
                          <a class="kub-footer-link" :href="'tel:' + contact.phoneTo.content">{{ contact.phone.content }}</a>
                        </b-col>
                        <div class="w-100" style="margin-bottom:1rem;"></div>
                        <b-col cols="auto">
                          <b-icon icon="envelope-fill" class="mr-2" font-scale="1" style="color:#ccc;"></b-icon>
                        </b-col>
                        <b-col class="p-0" style="color:#ccc;">
                          <a class="kub-footer-link" :href="'mailto:' + contact.mail.content">{{ contact.mail.content }}</a>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
          <div class="w-100"></div>
          <b-col>
            <b-card no-body class="mt-4 ml-3" style="border:none;background-color:#002b36;">
              <b-card-header class="p-0" style="border:none;">
                  <div class="text-uppercase mb-2 kub-footer-area-title">{{footer.paymentMethods.title}}</div>
              </b-card-header>
              <b-card-body class="pt-1 pb-0 pl-3">
                <b-card-text>
                  <b-row>
                    <ul class="kub-footer-list-inline">
                      <li class="mr-2">
                        <div class="kub-footer-payment-box">
                          <img :src="payment.methods.paypal.img.src" :alt="payment.methods.paypal.img.alt">
                        </div>
                      </li>
                      <li>
                        <div class="kub-footer-payment-box">
                          <img id="kub-footer-icon-bill" :src="payment.methods.bill.img.src" :alt="payment.methods.bill.img.alt">
                        </div>
                      </li>
                    </ul>
                  </b-row>
                </b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
          <div class="w-100"></div>
          <b-col>
            <b-card no-body class="mt-3 ml-3" style="border:none;background-color:#002b36;">
              <b-card-header class="p-0" style="border:none;">
                  <div class="text-uppercase mb-2 kub-footer-area-title">{{footer.socialmedia.title}}</div>
              </b-card-header>
              <b-card-body class="pt-1 pb-0 pl-3">
                <b-card-text>
                  <b-row>
                    <ul class="kub-footer-list-inline">
                      <li class="mr-2">
                        <a target="_blank" rel="noopener noreferrer" :href="footer.socialmedia.platform.facebook.href">
                          <img :src="footer.socialmedia.platform.facebook.img.src" :alt="footer.socialmedia.platform.facebook.img.alt" style="width:40px;">
                        </a>
                      </li>
                      <li class="mr-2">
                        <a target="_blank" rel="noopener noreferrer" :href="footer.socialmedia.platform.youtube.href">
                          <img :src="footer.socialmedia.platform.youtube.img.src" :alt="footer.socialmedia.platform.youtube.img.alt" style="width:40px;">
                        </a>
                      </li>
                      <li class="">
                        <a target="_blank" rel="noopener noreferrer" :href="footer.socialmedia.platform.pinterest.href">
                          <img :src="footer.socialmedia.platform.pinterest.img.src" :alt="footer.socialmedia.platform.pinterest.img.alt" style="width:40px;">
                        </a>
                      </li>
                    </ul>
                  </b-row>
                </b-card-text>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <hr>
        <b-row class="kub-max-width">
          <b-col class="d-flex justify-content-start p-0">
            <p id="kub-visitor-counter" class="align-self-center kub-color">{{counter}}</p>
          </b-col>
          <b-col class="d-flex justify-content-end pl-0">
            <p id="kub-copyright" class="align-self-center">{{footer.copyright}}</p>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </footer>
</template>

<script>
import DataFooter from '../../data/footer/footer'
import DataPayment from '../../data/main/summary/payment/payment'
import DataContact from './../../data/general/contact'
import UserService from '../../services/UserService'

import ShippingCosts from './../main/config/ShippingCosts.vue'
import DeliveryTime from './../general/DeliveryTime.vue'
import Sample from './../general/Sample.vue'
import Privacy from './../general/Privacy.vue'
import Terms from './../general/Terms.vue'
import Imprint from './../general/Imprint.vue'
import Disclaimer from './../general/Disclaimer.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      footer: DataFooter.footer,
      payment: DataPayment.payment,
      contact: DataContact.contact,
      counter: null
    }
  },
  components: {
    appShipping: ShippingCosts,
    appDeliveryTime: DeliveryTime,
    appSample: Sample,
    appPrivacy: Privacy,
    appTerms: Terms,
    appImprint: Imprint,
    appDisclaimer: Disclaimer
  },
  methods: {
    ...mapActions([
      'visitorLoadingError'
    ])
  },
  computed: {
    ...mapGetters([
      'lg'
    ])
  },
  async created () {
    try {
      const visitorData = await UserService.addVisitor()
      this.counter = visitorData.data.counter_id
    } catch (err) {
      this.visitorLoadingError()
      console.log(err)
    }
  }
}
</script>

<style scoped>
hr {
  margin: 15px 0 15px 0;
  border: 0;
  border-top: 1px solid rgba(209, 136, 136, 0.15);
}

.kub-footer {
  background-color: #002b36;
  color: #fff;
  z-index: 100;
}

.kub-footer-payment-box {
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 0.5rem;
  background-color: #fff;
}

#kub-footer-icon-bill {
  height: 26px !important;
  width: 100px !important;
}

.kub-footer-list-inline > li {
  display: inline-block;
}

.kub-footer-list > li {
  color: #ccc;
}

.kub-footer-list > li:focus {
  outline: none;
}

.kub-footer-list > li:hover {
  color: #fff;
}

.kub-footer-link {
  color: #ccc;
}

.kub-footer-link:hover {
  color: #fff;
  background-color: transparent;
}

.kub-footer-btn-mobile {
  color: #fff;
  background-color: #002b36;
}

.kub-footer-btn-mobile:hover {
  color: #fff;
  background-color: #002b36;
}

.kub-footer-btn-mobile:focus {
  outline: 0;
  background-color: #002b36;
}

.kub-footer-btn-mobile:active, .kub-footer-btn-mobile.active {
  background-color: #002b36;
}

.kub-footer-card-style {
 border-left: 0;
 border-top: 0;
 border-right: 0;
 border-bottom: 1px solid rgba(209, 136, 136, 0.15);
 background-color: #002b36;
}

.kub-footer-area-title {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.2;
}

</style>
